var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBargraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "icon-bargraph_svg__cls-1",
  d: "M21.38 2H15.1a.54.54 0 00-.54.54v4.74H8.82a.54.54 0 00-.54.54v4.75H2.54a.54.54 0 00-.54.54v8.13a.54.54 0 00.54.54h18.84a.54.54 0 00.54-.54V2.54a.54.54 0 00-.54-.54zM3.08 13.65h5.2v7h-5.2v-7zm6.28-.54V8.36h5.2V20.7h-5.2v-7.59zm11.48 7.59h-5.2V3.08h5.2V20.7z"
})));

export default SvgIconBargraph;